// #region CONSTANTES
export const RESSOURCE_TICKET_ACHATS = "ticket_achats";
// #endregion
